/**
 * Stytch Vanilla JS Headless Client Management
 * For truly browser-only environments (Office Add-ins, Chrome Extensions, etc.)
 * Uses @stytch/vanilla-js instead of @stytch/nextjs
 */
import { StytchB2BHeadlessClient } from '@stytch/vanilla-js/b2b/headless';
/**
 * Get or create the Stytch vanilla-js client instance
 * This version works in any browser environment without Next.js
 */
export function getStytchVanillaClient() {
    if (typeof window === 'undefined')
        return null;
    if (window.__stytchB2BVanilla)
        return window.__stytchB2BVanilla;
    const publicToken = process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN;
    if (!publicToken) {
        console.error('Stytch: NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN is missing. ' +
            'Check your .env.local and that it is prefixed with NEXT_PUBLIC_.');
        return null;
    }
    try {
        window.__stytchB2BVanilla = new StytchB2BHeadlessClient(publicToken);
        return window.__stytchB2BVanilla;
    }
    catch (err) {
        console.error('Stytch: failed to create B2B vanilla headless client:', err);
        window.__stytchB2BVanilla = null;
        return null;
    }
}
/**
 * Reset the Stytch vanilla client (useful for tests or explicit teardown)
 */
export function resetStytchVanillaClient() {
    if (typeof window !== 'undefined') {
        window.__stytchB2BVanilla = null;
    }
}
